<template>
  <div class="payment-vault">
    <section class="hero is-small is-primary top-section">
      <div class="hero-body">
        <div class="columns is-centered">
          <div class="column is-three-quarters">
            <div class="content">
              <h1 class="title has-text-white">Kolibri Payment Vaults</h1>

              <div v-if="$store.wallet !== null && !$store.contracts.PAYMENT_VAULTS[$store.walletAddress]" class="box no-vault">
                <p class="title is-4 has-text-centered">You have no payment vaults!</p>
              </div>
              <div v-else-if="$store.wallet === null" class="box no-vault">
                <p class="title is-4 has-text-centered">Please connect your wallet!</p>
              </div>
              <PaymentVaultInfo v-else :key="vault" :contract-address="vault" v-for="vault in $store.contracts.PAYMENT_VAULTS[$store.walletAddress]" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PaymentVaultInfo from "@/components/PaymentVaultInfo";
export default {
  name: 'PaymentVaults',
  components: {PaymentVaultInfo},
  async mounted(){},
  data(){
    return {
    }
  },
  methods:{

  },
  computed: {

  },
  watch: {
  }
}
</script>

<style lang="scss">
@import '../assets/sass/globals';
.payment-vault{
  .no-vault{
    min-height: 10rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .title{
      color: $grey-dark !important;
    }
  }
  .hero{
    min-height: 100vh;
    .title{
      display: flex;
      align-items: flex-end;
      justify-content: center;
      span.help{
        margin-bottom: 3px;
        margin-left: 3px;
      }
    }
  }
  .loader-wrapper{
    padding: 1rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
